class Multibanco {
  constructor(element, form) {
    this.sourceID = null
    this.element = element
    this.form = form
    this.stripe = Stripe(window.stripeKey, { locale: 'pt' })
    this.isValid = true
  }

  process() {
    return fetch(`${this.form.action}/multibanco`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.token
      }
    }).then(response => {
      return response.json()
    }).then(data => {
      window.location = data.location
    })
  }

  get token() {
    return document.querySelector('meta[name=csrf-token]').content
  }

  get valid() {
    return this.isValid
  }

  get automatic() {
    return false
  }
}

export default Multibanco